import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import Layout from "../components/layout"
import Seo from "../components/seo"

const FAQ = props => {
  const data = useStaticQuery(
    graphql`
      query {
        allContentfulFaq(
          filter: { tag: { eq: "Borger" }, node_locale: { eq: "da-DK" } }
        ) {
          edges {
            node {
              title
              id
              content {
                childMarkdownRemark {
                  html
                }
              }
            }
          }
        }
      }
    `
  )

  return (
    <Layout location={props.location}>
      <Seo title="FAQ" lang="da-DK" pathname="faq-borger" />
      <div className="content faq">
        <div>
          {data.allContentfulFaq.edges.map(edge => (
            <div key={edge.node.id}>
              <h1>{edge.node.title}</h1>
              <article
                dangerouslySetInnerHTML={{
                  __html: edge.node.content.childMarkdownRemark.html,
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </Layout>
  )
}

export default FAQ
